"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.InnerNMRiumContents = void 0;
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
/** @jsxImportSource @emotion/react */
const react_1 = require("@emotion/react");
const react_2 = require("react");
const checkModifierKeyActivated_1 = __importDefault(require("../../data/utilities/checkModifierKeyActivated"));
const Viewer1D_1 = __importDefault(require("../1d/Viewer1D"));
const FloatMoleculeStructures_1 = __importDefault(require("../1d-2d/components/FloatMoleculeStructures"));
const Viewer2D_1 = __importDefault(require("../2d/Viewer2D"));
const KeysListenerTracker_1 = __importDefault(require("../EventsTrackers/KeysListenerTracker"));
const ChartContext_1 = require("../context/ChartContext");
const Header_1 = __importDefault(require("../header/Header"));
const DropZone_1 = __importDefault(require("../loader/DropZone"));
const Panels_1 = __importDefault(require("../panels/Panels"));
const ToolBar_1 = __importDefault(require("../toolbar/ToolBar"));
const SplitPaneWrapper_1 = require("./SplitPaneWrapper");
const StateError_1 = require("./StateError");
const viewerContainerStyle = (0, react_1.css) `
  border: 0.55px #e6e6e6 solid;
  display: flex;
  flex: 1;
  flex-direction: column;
  height: 100%;
  margin-left: -1px;
`;
const containerStyles = (0, react_1.css) `
  background-color: white;
  width: 100%;
  display: block;
  height: 100%;

  div:focus {
    outline: none !important;
  }

  button {
    cursor: pointer;
  }

  button,
  button:active,
  button:hover,
  button:focus,
  [type='button']:focus {
    outline: none !important;
  }

  button:disabled {
    cursor: default;
  }

  * {
    -webkit-user-drag: none;
    -moz-user-drag: none;
    -o-user-drag: none;
    user-select: none;
  }
`;
function InnerNMRiumContents(props) {
    const { isFullscreenEnabled, toggleFullscreen, emptyText, mainDivRef, elementsWrapperRef, rootRef, viewerRef, } = props;
    const { displayerMode } = (0, ChartContext_1.useChartData)();
    const preventContextMenuHandler = (0, react_2.useCallback)((e) => {
        if (!(0, checkModifierKeyActivated_1.default)(e)) {
            e.preventDefault();
        }
    }, []);
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(StateError_1.StateError, {}), (0, jsx_runtime_1.jsx)("div", { className: "nmrium-container", ref: rootRef, css: containerStyles, onContextMenu: preventContextMenuHandler, style: { height: '100%', width: '100%' }, children: (0, jsx_runtime_1.jsx)(DropZone_1.default, { children: (0, jsx_runtime_1.jsxs)("div", { style: {
                            display: 'flex',
                            flexDirection: 'column',
                            backgroundColor: 'white',
                            width: '100%',
                        }, children: [(0, jsx_runtime_1.jsx)(Header_1.default, { isFullscreenEnabled: isFullscreenEnabled, onEnableFullscreen: toggleFullscreen }), (0, jsx_runtime_1.jsxs)("div", { style: {
                                    display: 'flex',
                                    flexDirection: 'row',
                                    height: '100%',
                                }, children: [(0, jsx_runtime_1.jsx)(ToolBar_1.default, {}), (0, jsx_runtime_1.jsxs)(SplitPaneWrapper_1.SplitPaneWrapper, { children: [(0, jsx_runtime_1.jsxs)("div", { css: viewerContainerStyle, children: [(0, jsx_runtime_1.jsx)(KeysListenerTracker_1.default, { mainDivRef: mainDivRef }), (0, jsx_runtime_1.jsxs)("div", { id: "nmrium-viewer", "data-testid": "viewer", ref: viewerRef, style: {
                                                            width: '100%',
                                                            height: '100%',
                                                            position: 'relative',
                                                        }, children: [(0, jsx_runtime_1.jsx)(FloatMoleculeStructures_1.default, {}), displayerMode === '1D' ? ((0, jsx_runtime_1.jsx)(Viewer1D_1.default, { emptyText: emptyText })) : ((0, jsx_runtime_1.jsx)(Viewer2D_1.default, { emptyText: emptyText }))] })] }), (0, jsx_runtime_1.jsx)(Panels_1.default, {})] }), (0, jsx_runtime_1.jsx)("div", { ref: elementsWrapperRef, id: "main-wrapper", style: {
                                            position: 'absolute',
                                            pointerEvents: 'none',
                                            zIndex: 2,
                                            left: 0,
                                            right: 0,
                                            top: 0,
                                            bottom: 0,
                                        } }, String(isFullscreenEnabled))] })] }) }) })] }));
}
exports.InnerNMRiumContents = InnerNMRiumContents;
